import React, { useState } from 'react';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Hidden from '@material-ui/core/Hidden';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import EmailIcon from '@material-ui/icons/Email';
import PhoneSharpIcon from '@material-ui/icons/PhoneSharp';
import AddIcon from '@material-ui/icons/Add';
import { useCustomerDetailsStyles } from './CustomerDetails';
import RemoveUser from './RemoveUser';

const UsersView = (props) => {
  const {
    isLoading,
    allowsSubusers,
    primary,
    subusers,
    handleEdit,
    setSortedSubusers,
    handleClickNewUser,
  } = props;

  const classes = useCustomerDetailsStyles();
  const minWidth800 = useMediaQuery('(min-width:800px)');

  const [openRemoveUser, setOpenRemoveUser] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);

  const handleOpenRemoveUser = (userId) => {
    setSelectedUserId(userId);
    setOpenRemoveUser(true);
  };

  if (isLoading) return <Typography>Loading...</Typography>;

  return allowsSubusers ? (
    <>
      {[primary, ...subusers].map((user) => (
        <Box
          display="flex"
          justifyContent={minWidth800 ? 'flex-start' : 'center'}
        >
          <Hidden smDown>
            <AccountBoxIcon
              className={classes.profilePhotoMini}
              style={{ marginBottom: '8px' }}
            />
          </Hidden>
          <Typography
            variant="subtitle1"
            className={classes.gray}
            style={{ marginRight: 5 }}
          >
            {`${user.firstName} ${user.lastName}`}
            {user.isPrimary && ' (Primary Account Owner)'}
          </Typography>
          <Button
            size="small"
            variant="text"
            className={classes.nowrap}
            onClick={() => handleEdit(user.id, user.isPrimary)}
            style={{ paddingHorizontal: 0 }}
          >
            Edit
          </Button>
          {!user.isPrimary && (
            <Button
              size="small"
              variant="text"
              className={classes.nowrap}
              onClick={() => handleOpenRemoveUser(user.id)}
              style={{ paddingHorizontal: 0 }}
            >
              <Typography variant="button" color="error">
                Remove
              </Typography>
            </Button>
          )}
        </Box>
      ))}
      <Box
        display="flex"
        justifyContent={minWidth800 ? 'flex-start' : 'center'}
      >
        <Button onClick={handleClickNewUser}>
          <AddIcon className={classes.addIcon} />
          <Typography variant="button">Add New User</Typography>
        </Button>
      </Box>
      {openRemoveUser && (
        <RemoveUser
          open={openRemoveUser}
          setOpen={setOpenRemoveUser}
          userId={selectedUserId}
          users={subusers}
          setUsers={setSortedSubusers}
        />
      )}
    </>
  ) : (
    <Box display="flex" flexDirection="column" justifyContent="flex-end">
      <Box
        display="flex"
        justifyContent={minWidth800 ? 'flex-start' : 'center'}
      >
        <Hidden smDown>
          <EmailIcon
            className={classes.contactIcon}
            style={{ marginBottom: '8px' }}
          />
        </Hidden>
        <Typography
          variant="subtitle1"
          className={classes.gray}
          style={{
            fontStyle: primary.email ? 'normal' : 'italic',
          }}
        >
          {primary.email || 'No email on file'}
        </Typography>
      </Box>
      <Box
        display="flex"
        justifyContent={minWidth800 ? 'flex-start' : 'center'}
      >
        <Hidden smDown>
          <PhoneSharpIcon className={classes.contactIcon} />
        </Hidden>
        <Typography variant="subtitle1" className={classes.gray}>
          {primary.phone}
        </Typography>
      </Box>
    </Box>
  );
};

export default UsersView;
